import { api } from "api/api";
import { AxiosError } from "axios";
import Usuario from "model/administracao/cadastro/Usuario";
import { ChartPieModel } from "model/chart/ChartPieModel";
import CategoriaDocumento from "model/documentos/CategoriaDocumento";
import Documento from "model/documentos/Documento";
import DocumentoAssociacao from "model/documentos/DocumentoAssociacao";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class DocumentoDashboardService {
    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {

            let url = `/documento/dashboard/pesquisar`;
            url += getFilters(filters)

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    pesquisarEmAlerta(page: Pageable) {
        return new Promise<Page>((resolve, reject): void => {

            let url = `/documento/dashboard/pesquisar/emAlerta`;
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    graficoPizza() {
        return new Promise<ChartPieModel>((resolve, reject): void => {

            let url = `/documento/dashboard/graficoPizza`;
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}

export default DocumentoDashboardService;